export default __webpack_public_path__ + "static/media/pin-svgrepo-com.d9bb32e9.svg";